import { Request } from '@/helpers'
import { ENDPOINTS } from '@/data'

const List = async (SetState: Function, push: Function) => {
    SetState({
        Tags: [],
        Loading: true
    })

    const { success, data } = await Request({
        path: ENDPOINTS.LIST_TAGS,
        method: 'GET'
    })

    if (success) SetState({
        Tags: data,
        Loading: false
    })
}

export default List
